<template>
    <router-link :to="to" :class="btnClass">
        <slot>This is a btn</slot>
    </router-link>
</template>

<script>
    export default {
        name: 'AppButton',
        props: {
            btnClass: {
                type: String,
                default: 'c-btn c-btn--primary',
            },
            to: {
                type: String,
                default: '#0',
            },
        },
    };
</script>
